module.exports = __webpack_public_path__ + "media/images/workplace/banners/uhrs_qualify_banner_variant7_image-e1bcdd245e4fd1bdda1d7ccea6098736.jpg";